import { FoodsSelect } from "@foodpilot/foods";
import { formatCompanyLabel, CompanySelectionProps } from "./CompanySelection";
import { useTranslation } from "react-i18next";
import { useIngredientContext } from "src/pages/Ingredient/IngredientDetails/useIngredientContext";
import { FoodsSelectTriggerAdapter } from "src/components/EntityForm/FoodsSelectTriggerAdapter";

export const CompanySelect = (props: CompanySelectionProps) => {
    const { appearance = "legacy", companies, onChange } = props;
    const { t } = useTranslation();
    const { activeCompanyId, posts } = useIngredientContext();

    const selectedCompany = companies.find((company) => company.id === activeCompanyId) ?? null;

    const select = (
        <FoodsSelect
            selectedOption={selectedCompany}
            options={companies}
            onChange={(company) => onChange(company)}
            getId={(company) => company.id}
            getName={(company) => {
                if (!posts) return company.name;

                const currentPost = posts.find((item) => item.organization?.id === company.id);
                const total = currentPost?.completions.ssq.result || 0;

                return formatCompanyLabel(company, total);
            }}
            textOptions={{
                placeholder: t("component.select.placeholder"),
                searchPlaceholder: t("component.select.searchplaceholder"),
                emptyOptionsText: t("component.select.nooptions"),
                defaultValueText: t("component.select.defaultvalue"),
                noResult: t("component.select.noresultfound"),
            }}
        />
    );

    return appearance === "product-v2" ?
            <FoodsSelectTriggerAdapter accessibleLabel={t("sidebar.selectorganization", "Select an organization")}>
                {select}
            </FoodsSelectTriggerAdapter>
        :   select;
};
